import { auth } from '../Config/Firebase'

import firebase from 'firebase/app'

//TYPES
import { GET_FIRSTNAME, GET_SAVED, GET_CURRENT, GET_ENERGYMONTH, GET_TODAY, GET_LIFETIME, GET_CO2, GET_TREES, GET_ANNUAL, GET_MONTH,GET_ANNUALPREVIOUS,GET_SELECTEDMONTH, GET_SELECTEDDAY,GET_SELECTEDDAYFROMWEEK } from './types'
import { GET_LASTNAME } from './types'
import { GET_ADDRESS } from './types'
import { GET_CONTRACT } from './types'
import { GET_JOBSTATUS } from './types'
import { GET_MONITORING } from './types'
import { GET_NEM } from './types'
import { GET_PERMIT } from './types'
import { GET_PHONENUMBER } from './types'
import { GET_POWRGUARD } from './types'
import { GET_ROLE } from './types'
import { GET_SALESREPEMAIL } from './types'
import { GET_SALESTYPE } from './types'
import { GET_SALESREP } from './types'
import { GET_SITEPLANS } from './types'
import { GET_SYSTEMSIZE } from './types'
import { GET_ZIPCODE } from './types'
import { GET_EMAIL } from './types'
import { GET_UID } from './types'

//get this year data
import { GET_DAILY } from './types'

import { GET_WEEK } from './types'


let db = firebase.firestore();
let usersRef = db.collection("Users");

let currentYear = new Date().getFullYear().toString();
let previousYear = currentYear - 1;

let date= new Date();
let dd = date.getDate();
let mm = date.getMonth() +1;
let year = date.getFullYear();

const monthNames = ["Jan", "Feb", "March", "April", "May", "June","July", "Aug", "Sept", "Oct", "Nov", "Dec"];

let currentMonthWithYear = monthNames[mm - 1] + year.toString();

let today = mm.toString() +dd.toString()+year.toString();
let todayToString = today.toString();
//get first name
export function getFirebaseData() {
    return dispatch => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                //get firebase info
                //non chart data 
                usersRef.doc(user.uid).collection("Monitoring").doc("NonGraphsData").onSnapshot(doc => {
                    if(doc.data() != undefined) {
                        dispatch({
                            type: GET_SAVED, 
                            payload: doc.data().Saved
                        });
                        dispatch({
                            type: GET_CURRENT, 
                            payload: doc.data().Current
                        });
                        dispatch({
                            type: GET_ENERGYMONTH, 
                            payload: doc.data().EnergyMonth
                        });
                        dispatch({
                            type: GET_TODAY, 
                            payload: doc.data().EnergyToday
                        });
                        dispatch({
                            type: GET_LIFETIME, 
                            payload: doc.data().Lifetime
                        });
                        dispatch({
                            type: GET_CO2, 
                            payload: doc.data().CO2
                        });
                        dispatch({
                            type: GET_TREES, 
                            payload: doc.data().Trees
                        });
                    }
                })

                //daily data pull
                
                    usersRef.doc(user.uid).collection("Monitoring").doc("Daily").collection("Days").doc(todayToString).get().then(doc => {


                        if(doc.data() != undefined){
                            dispatch({
                                type: GET_DAILY, 
                                payload: doc.data()
                            });
                          
                        }
                    }); 
                
                
                //weekly data pull
                    usersRef.doc(user.uid).collection("Monitoring").doc("Week").get().then(doc => {
                    if(doc.data() != undefined){
                            dispatch({
                                type: GET_WEEK, 
                                payload: doc.data()
                            });
                           
                    
                        }
                    })

                    usersRef.doc(user.uid).collection("Monitoring").doc("Month").collection("Months").doc(currentMonthWithYear).get().then(doc => {
                        if(doc.data() != undefined) {
                                dispatch({
                                    type: GET_MONTH, 
                                    payload: doc.data()
                                });
                            }
                    })
                    //ANNUAL DATA PULL Current Year
                    usersRef.doc(user.uid).collection("Monitoring").doc("Annually").collection("Annual").doc(currentYear).get().then(doc => {
                        if(doc.data() != undefined) {
                                dispatch({
                                    type: GET_ANNUAL, 
                                    payload: doc.data()
                                });
                            }
                            
                        
                    })

                    //ANNUAL DATA PULL PREVIOUS YEAR
                    usersRef.doc(user.uid).collection("Monitoring").doc("Annually").collection("Annual").doc(previousYear.toString()).get().then(doc => {
                        if(doc.data() != undefined) {
                                dispatch({
                                    type: GET_ANNUALPREVIOUS, 
                                    payload: doc.data()
                                });
                            }
                            
                        
                    })


                    usersRef.doc(user.uid).get().then(doc => {
                        dispatch({
                            type: GET_FIRSTNAME, 
                            payload: doc.data().FirstName,
                        });
                        dispatch({
                            type: GET_LASTNAME, 
                            payload: doc.data().LastName
                        });
                        dispatch({
                            type: GET_ADDRESS, 
                            payload: doc.data().Address
                        });
                        dispatch({
                            type: GET_CONTRACT, 
                            payload: doc.data().Contract
                        });dispatch({
                            type: GET_JOBSTATUS, 
                            payload: doc.data().JobStatus
                        });dispatch({
                            type: GET_MONITORING, 
                            payload: doc.data().Monitoring
                        });dispatch({
                            type: GET_NEM, 
                            payload: doc.data().NEM
                        });dispatch({
                            type: GET_PERMIT, 
                            payload: doc.data().Permit
                        });dispatch({
                            type: GET_PHONENUMBER, 
                            payload: doc.data().PhoneNumber
                        });dispatch({
                            type: GET_POWRGUARD, 
                            payload: doc.data().PowrGuard
                        });dispatch({
                            type: GET_ROLE, 
                            payload: doc.data().Role
                        });dispatch({
                            type: GET_SALESREPEMAIL, 
                            payload: doc.data().SalesRepEmail
                        });dispatch({
                            type: GET_SALESTYPE, 
                            payload: doc.data().SalesType
                        });dispatch({
                            type: GET_SALESREP, 
                            payload: doc.data().SalesRep
                        });dispatch({
                            type: GET_SITEPLANS, 
                            payload: doc.data().SitePlans
                        });dispatch({
                            type: GET_SYSTEMSIZE, 
                            payload: doc.data().SystemSize
                        });dispatch({
                            type: GET_ZIPCODE, 
                            payload: doc.data().ZipCode
                        });dispatch({
                            type: GET_EMAIL, 
                            payload: doc.data().Email
                        });
                        dispatch({
                            type: GET_UID, 
                            payload: user.uid
                        });
                       
                })

            }
        });
    }
}    


export function getSelectedMonthData(selectedMonth) {
    return dispatch => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                //get firebase info
                //non chart data 
                //PUll DATA FOR A SELECTED MONTH
                
                var month = selectedMonth.replace(/\s+/g, '');
                
                 usersRef.doc(user.uid).collection("Monitoring").doc("Month").collection("Months").doc(month.toString()).get().then(doc => {
                   
                    if(doc.data() != undefined) {
                        console.log("ran");
                            dispatch({
                                type: GET_SELECTEDMONTH, 
                                payload: doc.data()
                            });
                        } else{
                            dispatch({
                                type: GET_SELECTEDMONTH, 
                                payload: "No"
                            });
                        }
                        
                    
                })
            }
        })
    }
}
        
export function getSelectedDay(selectedDay,monthOfDay,yearOfDay) {
    return dispatch => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                //get firebase info
                //non chart data 
                //PUll DATA FOR A SELECTED DAY
                var monthAsNumber = monthToNumber(monthOfDay);
                var pullDataForDate = monthAsNumber+selectedDay+yearOfDay

                usersRef.doc(user.uid).collection("Monitoring").doc("Daily").collection("Days").doc(pullDataForDate.toString()).get().then(doc => {

                    if(doc.data() != undefined) {
                        console.log("got day")
                            dispatch({
                                type: GET_SELECTEDDAY, 
                                payload: doc.data()
                            });
                        } else{
                            dispatch({
                                type: GET_SELECTEDDAY, 
                                payload: "No"
                            });
                        }
                        
                    
                })
            }
        })
    }
}

export function getSelectedDayFromWeek(getSelectedDayFromWeek) {
    return dispatch => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                //get firebase info
                //non chart data 
                //PUll DATA FOR A SELECTED DAY FROM THE WEEKLY CHART
                var d = getSelectedDayFromWeek.replace(/\//g, "");
                console.log(d)
                usersRef.doc(user.uid).collection("Monitoring").doc("Daily").collection("Days").doc(d).get().then(doc => {
                    
                    if(doc.data() != undefined) {
                        console.log("got day")
                            dispatch({
                                type: GET_SELECTEDDAYFROMWEEK, 
                                payload: doc.data()
                            });
                        } else{
                            console.log("anything")
                            dispatch({
                                type: GET_SELECTEDDAYFROMWEEK, 
                                payload: "No"
                            });
                        }
                        
                    
                })
            }
        })
    }
}
    
function monthToNumber(month){
    var monthArray = [1,2,3,4,5,6,7,8,9,10,11,12]

    if(month === 'Jan'){
        return monthArray[0]
    }
    if(month === 'Feb'){
        return monthArray[1]
    }
    if(month === 'March'){
        return monthArray[2]
    }
    if(month === 'April'){
        return monthArray[3]
    }
    if(month === 'May'){
        return monthArray[4]
    }
    if(month === 'June'){
        return monthArray[5]
    }
    if(month === 'July'){
        return monthArray[6]
    }
    if(month === 'Aug'){
        return monthArray[7]
    }
    if(month === 'Sept'){
        return monthArray[8]
    }
    if(month === 'Oct'){
        return monthArray[9]
    }
    if(month === 'Nov'){
        return monthArray[10]
    }
    if(month === 'Dec'){
        return monthArray[11]
    }
    
    return 
}


// WEBPACK FOOTER //
// ./src/Actions/FirebaseDataAction.js